import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=6b789db9"
import script from "./ButtonList.vue?vue&type=script&lang=js"
export * from "./ButtonList.vue?vue&type=script&lang=js"
import style0 from "./ButtonList.vue?vue&type=style&index=0&id=6b789db9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports